const renderCards = ($formUrl, $data) => {
  $.ajax({
    url: $formUrl,
    type: 'GET',
    data: $data,
    success(data) {
      $('@makedPicks').replaceWith(data);
    },
    error(data) {
      console.log('woops!');
    },
  });
};

export default renderCards;
